<template>
  <div>
    <div class="primary--text h-preloader-text">{{ __('preloading') }}</div>
    <div class="h-preloader-cart">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="120">
        <path fill="#de5813" d="M37.88 61.201a462.65 462.65 0 0 0 8.29 28.502L95.521 67.63l-8.391-27.984C70.948 46.308 37.88 61.201 37.88 61.201M31.066 27.344c2.144 10.637 4.53 20.53 7.686 30.911 9.06-4.364 19.256-7.462 28.316-11.826-2.051-9.037-5.396-19.305-7.761-28.266-8.559 2.126-28.241 9.181-28.241 9.181"/>
        <path fill="#fff" d="M55.473 15.477a1.084 1.084 0 0 0-.403.069 188.214 188.214 0 0 0-24.413 11.56.885.885 0 0 0-.46.926 137.796 137.796 0 0 0 8.167 30.304c.404 1.02 1.933.263 1.53-.755a135.217 135.217 0 0 1-6.847-23.149c-.447-2.23-.755-3.877-1.092-6.126 7.85-4.433 14.58-7.629 22.984-10.892A421.315 421.315 0 0 0 65.81 45.48c-8.4 3.82-16.076 7.308-24.475 11.129-1 .454-.246 1.986.755 1.532L67.288 46.68c.436-.198.565-.73.388-1.144a448.328 448.328 0 0 1-11.463-29.602c-.11-.317-.427-.452-.74-.457ZM5.55 17.11c-.914-.026-1.703.85-1.724 1.73-.025 1.01.77 1.723 1.725 1.811l8.492.782c1.179.108 2.578.102 3.65.371.69.174.782.84 1.012 1.59.807 2.633 1.615 5.266 2.425 7.898 2 6.51 4.009 13.019 6.031 19.522a2973.484 2973.484 0 0 0 6.48 20.602c1.825 5.72 3.665 11.435 5.601 17.118.103.302.208.604.312.905-4.416 2.524-6.818 7.766-5.528 12.939 1.554 6.234 7.89 10.041 14.124 8.487 6.234-1.555 10.041-7.89 8.487-14.125a11.582 11.582 0 0 0-2.37-4.656c6.828-2.802 13.658-5.582 20.47-8.518l10.018-4.315c1.825-.787 1.069-3.408-.556-3.445a1.773 1.773 0 0 0-.744.155l-31.91 13.748a11.732 11.732 0 0 0-2.794-1.285c.124-.017.253-.058.386-.132 11.014-6.172 20.954-10.782 32.69-15.44a286.078 286.078 0 0 1 10.04-3.765c.39-.138.709-.755.575-1.157a181.429 181.429 0 0 1-6.725-26.943c-.12-.703-.902-1.035-1.52-.756a1282.17 1282.17 0 0 1-46.894 20.143c-.571.233-.674.922-.485 1.429 3.2 8.59 5.63 16.202 7.829 25.103.327 1.328 2.425.934 2.095-.401-2.244-9.084-4.352-15.817-7.62-24.586A1220.988 1220.988 0 0 0 83.854 42.72c1.55 9.137 3.304 15.962 6.23 24.757-11.901 4.214-22.683 8.91-33.92 14.665-3.182 1.63-4.852 2.489-7.97 4.236-.794.445-.645 1.443-.102 1.863a11.573 11.573 0 0 0-5.244-.067c-1.822-5.315-3.548-10.663-5.26-16.014a2747.646 2747.646 0 0 1-6.571-20.849c-2.07-6.65-4.125-13.304-6.172-19.961l-2.517-8.196c-.27-.88-.5-1.8-.927-2.62-.615-1.18-1.734-1.948-3.03-2.193-1.39-.263-2.832-.315-4.24-.445l-4.246-.391-4.246-.391a1.401 1.401 0 0 0-.089-.005zm39.406 73.215c4.37.037 8.574 3.71 9.391 6.986 1.24 4.972-1.796 10.025-6.768 11.264-4.97 1.24-10.024-1.796-11.263-6.768-1.24-4.971 1.796-10.024 6.767-11.264a7.464 7.464 0 0 1 1.873-.218zm.398 5.022a4.025 4.025 0 0 0-4.025 4.025 4.025 4.025 0 0 0 4.025 4.025 4.025 4.025 0 0 0 4.026-4.025 4.025 4.025 0 0 0-4.026-4.025z"/>
      </svg>
    </div>
    <div class="h-preloader-progress">
      <v-progress-linear
        indeterminate
        rounded
        background-color="white"
        background-opacity=".6"
      />
    </div>
    <v-footer app color="secondary">
      <v-spacer />
      <h-version top />
    </v-footer>
  </div>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import HVersion from '@/Components/Version'

  export default {
    mixins: [
      I18n,
    ],

    components: {
      HVersion,
    },
  }
</script>

<style lang="scss" scoped>
  .h-preloader-text {
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    max-width: 240px;
    margin: 0 auto;
  }
  .h-preloader-cart {
    position: absolute;
    width: 100vw;
    bottom: 12vh;
    left: 0;
  }
  .h-preloader-cart svg {
    margin-left: -500px; // hidden
    animation: cart 4s linear infinite;
  }
  .h-preloader-progress {
    position: absolute;
    width: 90vw;
    bottom: 10vh;
    left: 5vw;
  }
  @keyframes cart {
    0%   {margin-left: -300px}
    100% {margin-left: 100vw}
  }
  @media only screen and (min-width: 400px) {
    .h-preloader-cart svg {
      animation-duration: 6s;
    }
  }
  @media only screen and (min-width: 600px) {
    .h-preloader-cart svg {
      animation-duration: 8s;
    }
  }
  @media only screen and (min-width: 1200px) {
    .h-preloader-cart svg {
      animation-duration: 10s;
    }
  }
</style>
